import { authClient } from "@/shared/lib/axios";
import {
	type ExecutionCommandResponse,
	ExecutionCommandResponseSchema,
	type ExecutionStatusResponse,
	ExecutionStatusResponseSchema,
} from "./execution.types";

const EXECUTION_ENDPOINT = "/execution";

export const executionApi = {
	getStatus: async (workflowId: string): Promise<ExecutionStatusResponse> => {
		const { data } = await authClient.get(`${EXECUTION_ENDPOINT}/${workflowId}/status`);
		return ExecutionStatusResponseSchema.parse(data);
	},

	start: async (workflowId: string): Promise<ExecutionCommandResponse> => {
		const { data } = await authClient.post(`${EXECUTION_ENDPOINT}/${workflowId}/start`);
		return ExecutionCommandResponseSchema.parse(data);
	},

	stop: async (workflowId: string): Promise<ExecutionCommandResponse> => {
		const { data } = await authClient.post(`${EXECUTION_ENDPOINT}/${workflowId}/stop`);
		return ExecutionCommandResponseSchema.parse(data);
	},
};
